export const upperCaseFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function removeCountryCode(phoneNumber: string = '') {
  // Regular expression to match country codes
  var countryCodeRegex = /^\+?\d{1,3}/;
  var countryCodeRegexValid = /^\+\d{1,3}/;

  if (!countryCodeRegexValid.test(phoneNumber)) return phoneNumber;

  // Remove the country code
  var cleanedNumber = phoneNumber.replace(countryCodeRegex, '');

  return cleanedNumber;
}
